import React from "react";
export const User = () =>{
    return(
        <div>helo</div>
    )
}